/**
 * @name API Config
 * @memberof module:common/config
 * @type {Config}
 * @return {Object} Configurations of API
 */

import { API } from '../config';

const base = `${API.BASE_DEV_HOST}/api/fund-investments`;

// Update the fund investment details
export const updateFundInvestmentDetails = (allocationId: number) => `${base}/${allocationId}/`;
